module.exports = __webpack_public_path__ + "static/media/worldpay-dark.a99e6d1c.svg";